import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import originalImage from "../Images/DeskPapers.jpg";
import blurredImage from "../Images/BlurredDeskPapers.jpg";
import "./hero.css";

interface HeroProps {
  backgroundImage: string;
  logoImage: string;
  headerText: string;
  subheaderText: string;
}

export const Hero = (props: HeroProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = originalImage;
    img.onload = () => setImageLoaded(true);
  }, []);
  return (
    <>


      <div style={{ position: "relative", height: "500px", overflow: "hidden" }}>
        {/* Blurred background */}
        <div className="hero-section"
          style={{
            backgroundImage: `
            linear-gradient(to bottom right, rgba(30, 30, 63, 0.6), rgba(255, 204, 0, 0.3)),
            url(${blurredImage})
          `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(20px)",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            // transition: "opacity 0.5s ease",
            opacity: imageLoaded ? 0 : 1,
          }}
        />

        {/* High-res background */}
        <div className="hero-section"
          style={{
            backgroundImage: `
            linear-gradient(to bottom right, rgba(30, 30, 63, 0.6), rgba(255, 204, 0, 0.3)),
            url(${originalImage})
          `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
            // transition: "opacity 2s ease",
            opacity: imageLoaded ? 1 : 0,
          }}
        />
        {/* Overlay and main content */}
        <div
          className="overlay-text centeredTextOverlay"
          style={{
            background: 'rgba(30, 30, 63, 0.6)',
            padding: '1.5rem',
            borderRadius: '12px',
            maxWidth: '90%',
            margin: '0 auto',
            textAlign: 'center',
            zIndex: 20,
            animation: 'fadeInUp 1.2s ease-out',
          }}
        >
          <h1
            style={{
              color: '#fefefe',
              margin: '20px 0 10px',
              textShadow: '0 2px 6px rgba(0, 51, 102, 0.6)',
            }}
          >
            {props.headerText}
          </h1>
          <p
            style={{
              color: '#fdfdfd',
              textShadow: '0 1px 4px rgba(0, 51, 102, 0.5)',
            }}
          >
            {props.subheaderText}
          </p>
        </div>
      </div>
      {/* Contact Info at Bottom of Hero */}
      <Container fluid style={{ background: 'linear-gradient(to right, #1e1e3f, #003366)', padding: '1rem 0' }}>
        <Row className="justify-content-center text-center g-3 px-3">
          {/* Phone */}
          <Col xs={12} sm={2}>
            <a
              href="tel:0738784875"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'orange',
                color: '#1e1e3f',
                padding: '0.8rem 1.2rem',
                borderRadius: '50px',
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e6b800')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'orange')}
            >
              <FontAwesomeIcon icon={faPhone} style={{ marginRight: '10px' }} />
              073 878 4875
            </a>
          </Col>

          {/* Email */}
          <Col xs={12} sm={2}>
            <a
              href="mailto:info@logosbrokers.co.za"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#ffffff',
                color: '#1e1e3f',
                padding: '0.8rem 1.2rem',
                borderRadius: '50px',
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#ffffff')}
            >
              <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '10px' }} />
              info@logosbrokers.co.za
            </a>
          </Col>

          {/* WhatsApp */}
          <Col xs={12} sm={2}>
            <a
              href="https://wa.me/27738784875"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#25D366',
                color: '#fff',
                padding: '0.8rem 1.2rem',
                borderRadius: '50px',
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1ebd5a')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
            >
              <FontAwesomeIcon icon={faWhatsapp as IconProp} style={{ marginRight: '10px' }} />
              WhatsApp Us
            </a>
          </Col>
        </Row>
      </Container>
      {/* Floating WhatsApp Button */}
      <Button
        variant="success"
        href="https://wa.me/27738784875"
        target="_blank"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          padding: "10px 20px",
          fontSize: "1.2rem",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#25D366",
          borderColor: "#25D366",
          borderRadius: "50px",
          color: "white",
          zIndex: 1000,
        }}
      >
        <FontAwesomeIcon icon={faWhatsapp as IconProp} size="lg" style={{ marginRight: "8px" }} />
      </Button>
    </>
  );
};